import pick from 'lodash/pick'
import { User } from 'shared/types/User'

export const USER_FIELDS = [
  'availableCreditCents',
  'email',
  'id',
  'isGuest',
  'name',
  'username',
] as const

export type PrunedUser = Pick<User, (typeof USER_FIELDS)[number]>

// Filter user data with minimum fields
export function pruneUserFields(userData: User): PrunedUser {
  return pick(userData, USER_FIELDS)
}
